import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { useTranslation } from "react-i18next"
import { numberToCurrency } from "helpers/string"
import styles from "./BookingPanel.module.css"

// Guest lines, one "Taxes & Fees" line, and the total — with the undiscounted total struck through
// and the saving spelled out when the date is discounted.
const PriceSummary = ({ summary }) => {
  const { t } = useTranslation()

  return (
    <Flex vertical gap={8} className={styles.summary}>
      {summary.lines.map((line) => (
        <Flex key={line.key} justify="space-between" gap={12}>
          <span>{t(`booking_widget.experience.summary.${line.kind}`, { count: line.count, title: line.title })}</span>
          <span>{numberToCurrency(line.value)}</span>
        </Flex>
      ))}
      {summary.taxesAndFees > 0 && (
        <Flex justify="space-between" gap={12}>
          <span>{t("booking_widget.experience.summary.taxes_and_fees")}</span>
          <span>{numberToCurrency(summary.taxesAndFees)}</span>
        </Flex>
      )}
      <div className={styles.summaryDivider} />
      <Flex justify="space-between" align="baseline" gap={12}>
        <span className={styles.totalLabel}>{t("booking_widget.experience.summary.total")}</span>
        <span>
          {summary.originalTotal != null && <span className={styles.struck}>{numberToCurrency(summary.originalTotal)}</span>}
          <span className={styles.totalAmount}>{numberToCurrency(summary.total)}</span>
        </span>
      </Flex>
      {summary.savedAmount > 0 && (
        <span className={styles.savedText}>{t("booking_widget.experience.summary.saved", { amount: numberToCurrency(summary.savedAmount) })}</span>
      )}
    </Flex>
  )
}

PriceSummary.propTypes = {
  summary: PropTypes.shape({
    lines: PropTypes.arrayOf(
      PropTypes.shape({ key: PropTypes.string, kind: PropTypes.string, count: PropTypes.number, value: PropTypes.number, title: PropTypes.string })
    ).isRequired,
    taxesAndFees: PropTypes.number,
    total: PropTypes.number,
    originalTotal: PropTypes.number,
    savedAmount: PropTypes.number
  }).isRequired
}

export default PriceSummary
